import { Analytics } from '@cobliteam/analytics';

import type { UUID } from '@cobliteam/common-types';
import { useActiveTrigger } from '@cobliteam/hooks/src/useEntity/useAlerts';
import { Button, Dialog, Typography } from '@cobliteam/ui/components';
import { useEffect } from 'react';

interface TriggerDisableDialogProps {
  triggerId: UUID;
  open: boolean;
  setOpen: (open: boolean) => void;
  onCancel?: () => void;
}

const TriggerDisableDialog = ({ triggerId, open, setOpen, onCancel }: TriggerDisableDialogProps) => {
  const { isPending, isSuccess, mutate } = useActiveTrigger(triggerId, false);

  useEffect(() => {
    if (!isPending && isSuccess) {
      setOpen(false);
      onCancel?.();
    }
  }, [isPending, isSuccess, setOpen]);

  const handleConfirmDisableRule = () => {
    mutate();
    Analytics.track('Rule Disable Clicked');
  };

  if (!triggerId) return null;

  return (
    <Dialog open={open}>
      <Dialog.Content modalSize='sm'>
        <Dialog.Header>
          <Dialog.Title>Desativar alerta</Dialog.Title>
          <Dialog.Description className='sr-only' />
          <Dialog.Close
            onClick={() => {
              setOpen(false);
              onCancel?.();
            }}
          />
        </Dialog.Header>

        <Dialog.Body>
          <Typography variant='description-list-default'>
            Ao desativar este alerta, novos acionamentos deixarão de ser gerados para toda a frota e nenhuma nova notificação será enviada. Os acionamentos anteriores à desativação
            continuarão disponíveis no histórico de alertas.
          </Typography>
        </Dialog.Body>

        <Dialog.Footer className='flex justify-end gap-4'>
          <Dialog.Close asChild>
            <Button
              variant='ghost'
              onClick={() => {
                setOpen(false);
                onCancel?.();
              }}
            >
              Cancelar
            </Button>
          </Dialog.Close>
          <Dialog.Close asChild>
            <Button color='danger' onClick={handleConfirmDisableRule} loading={isPending}>
              Desativar alerta
            </Button>
          </Dialog.Close>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  );
};

export default TriggerDisableDialog;
